import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowIcon } from '../../assets/images/CoreBankingModulesImages/arrow.svg';
import {
  ContFAQSection,
  TitleFAQ,
  FAQList,
  FAQItem,
  FAQQuestion,
  QuestionText,
  IconButton,
  FAQAnswer,
  AnswerText,
} from './CoreBancarioFAQ.styles';

const faqData = [
  {
    id: 1,
    question: '¿Qué es un Core Bancario?',
    answer: 'Un Core Bancario es una herramienta o sistema centralizado que permite que bancos y otras entidades financieras puedan digitalizar y gestionar sus operaciones diarias. Funcionando así, como un núcleo tecnológico que integra todos los procesos críticos de una institución financiera, incluyendo la contabilidad, la gestión de depósitos, préstamos, pagos, transferencias, entre otros.',
  },
  {
    id: 2,
    question: '¿Qué es un Core Bancario modular?',
    answer: 'Un Core Bancario modular se adapta a diferentes modelos de negocio, a través de módulos integrables mediante API que optimizan la gestión de productos financieros de principio a fin.',
  },
  {
    id: 3,
    question: '¿Qué beneficios tiene un Core Bancario escalable?',
    answer: 'La flexibilidad del Core Bancario de Dynamicore permite a cada Entidad Financiera decidir qué módulos implementar desde el inicio y crecer de acuerdo con sus necesidades.',
  },
  {
    id: 4,
    question: '¿Por qué elegir un Core Bancario API-ficado?',
    answerIntro: 'Elegir un core bancario API-ficado como Dynamicore significa contar con una plataforma flexible y moderna que se conecta fácilmente con otros sistemas y servicios financieros. Gracias a sus APIs abiertas, permite:',
    answerList: [
      'Integrar rápidamente nuevos productos digitales.',
      'Reducir tiempos y costos de implementación.',
      'Escalar sin limitarse a un modelo rígido de core bancario tradicional.',
      'Mejorar la experiencia del cliente con servicios personalizados y en tiempo real.',
      'Lanzar y operar soluciones en un time to market muy corto, acelerando la innovación.',
    ],
    answerClosing: 'En pocas palabras, un core bancario API-ficado te da la agilidad, rapidez e innovación necesarias para competir en el ecosistema financiero actual.',
  },
];

export const CoreBancarioFAQ = () => {
  const { t } = useTranslation();
  const [openItem, setOpenItem] = useState(null);

  const toggleItem = (id) => {
    setOpenItem(openItem === id ? null : id);
  };

  return (
    <ContFAQSection>
      <TitleFAQ>
        {t('Preguntas frecuentes')}
      </TitleFAQ>
      <FAQList>
        {faqData.map((faq) => (
          <FAQItem key={faq.id} isOpen={openItem === faq.id}>
            <FAQQuestion
              onClick={() => toggleItem(faq.id)}
              isOpen={openItem === faq.id}
            >
              <QuestionText isOpen={openItem === faq.id}>{t(faq.question)}</QuestionText>
              <IconButton isOpen={openItem === faq.id}>
                <ArrowIcon />
              </IconButton>
            </FAQQuestion>
            <FAQAnswer isOpen={openItem === faq.id}>
              {faq.answerIntro ? (
                <div>
                  <AnswerText as="p">{t(faq.answerIntro)}</AnswerText>
                  <ul>
                    {faq.answerList.map((item, idx) => (
                      <li key={idx}><AnswerText as="span">{t(item)}</AnswerText></li>
                    ))}
                  </ul>
                  <AnswerText as="p" style={{ marginTop: 16 }}>{t(faq.answerClosing)}</AnswerText>
                </div>
              ) : (
                <AnswerText>{t(faq.answer)}</AnswerText>
              )}
            </FAQAnswer>
          </FAQItem>
        ))}
      </FAQList>
    </ContFAQSection>
  );
};
